import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

const STATS = [
    { value: "£/$", label: "UK & US friendly" },
    { value: "0", label: "Judgement. Just data" },
    { value: "1:1", label: "Real human calls" },
];

export const About = () => {
    return (
        <section
            id="about"
            data-testid="about-section"
            className="bg-[#11141D] border-y border-white/10"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-32 grid md:grid-cols-12 gap-10 md:gap-16 items-center">
                <motion.div
                    initial={{ opacity: 0, scale: 0.94 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 1, ease }}
                    className="md:col-span-5"
                >
                    <div className="relative aspect-[3/4] overflow-hidden">
                        <img
                            src="https://images.unsplash.com/photo-1590650153855-d9e808231d41?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000"
                            alt="The analyst behind The Raw Math"
                            className="w-full h-full object-cover"
                        />
                        <div className="absolute bottom-5 left-5 right-5 bg-[#11141D]/85 backdrop-blur-md p-4 border border-white/5">
                            <p className="font-mono text-xs text-white/60">
                                THE METHOD
                            </p>
                            <p className="font-body font-semibold">
                                Data → clarity → power to choose
                            </p>
                        </div>
                    </div>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 1, delay: 0.15, ease }}
                    className="md:col-span-6 md:col-start-7"
                >
                    <p className="overline text-[#C5A059] mb-6">— The method</p>
                    <h2 className="font-display text-3xl md:text-5xl tracking-tighter leading-tight mb-8">
                        Math never{" "}
                        <span className="italic text-[#C5A059]">lies</span>. So
                        neither do I.
                    </h2>
                    <p className="font-body text-lg text-[#8E95A3] leading-relaxed max-w-xl mb-6">
                        I&apos;m a data analyst. Instead of building reports for
                        big corporations, I put that same skill to work for
                        you — for the people who want to relocate,
                        buy the home, or finally get ahead but were never handed
                        the numbers to do it.
                    </p>
                    <p className="font-body text-lg text-[#8E95A3] leading-relaxed max-w-xl">
                        I show you exactly where you stand and the shortest path
                        forward. No hacks, no hype, no shame — just your real
                        numbers turned into a plan you can actually follow.
                    </p>

                    <div className="grid grid-cols-3 gap-6 mt-12">
                        {STATS.map((s) => (
                            <div key={s.label}>
                                <p className="font-display text-4xl md:text-5xl text-[#FDFBF7]">
                                    {s.value}
                                </p>
                                <p className="font-mono text-xs text-white/50 mt-2 uppercase tracking-wider">
                                    {s.label}
                                </p>
                            </div>
                        ))}
                    </div>
                </motion.div>
            </div>
        </section>
    );
};
